import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <div className="flex flex-col leading-none mb-4">
                <span className="font-heading text-xl md:text-2xl font-bold tracking-tight text-white">
                  Rahmede
                </span>
                <span className="text-[10px] md:text-xs tracking-[0.2em] uppercase text-background-300/60">
                  Druckerei
                </span>
              </div>
              <p className="text-sm text-background-300/60 leading-relaxed mt-3 max-w-xs">
                Ihr regionaler Druck- und Siebdruckbetrieb in Schalksmühle-Heedfeld. Tradition, Qualität und persönlicher Service seit vielen Jahren.
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">
                Leistungen
              </h4>
              <ul className="space-y-2.5">
                {['Siebdruck', 'Geschäftsausstattung', 'Flyer & Broschüren', 'Plakate & Werbemittel', 'Aufkleber & Etiketten', 'Sonderanfertigungen'].map((item) => (
                  <li key={item}>
                    <Link to="/leistungen" className="text-sm text-background-300/60 hover:text-accent-400 transition-colors">
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">
                Unternehmen
              </h4>
              <ul className="space-y-2.5">
                {[
                  { label: 'Über uns', to: '/ueber-uns' },
                  { label: 'Leistungen', to: '/leistungen' },
                  { label: 'Kontakt', to: '/kontakt' },
                  { label: 'Impressum', to: '/impressum' },
                  { label: 'Datenschutz', to: '/datenschutz' },
                ].map((item) => (
                  <li key={item.label}>
                    <Link to={item.to} className="text-sm text-background-300/60 hover:text-accent-400 transition-colors">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">
                Kontakt
              </h4>
              <div className="space-y-2.5 text-sm text-background-300/60">
                <p>Rahmede GmbH</p>
                <p>Unterm Eichholz 8</p>
                <p>58579 Schalksmühle-Heedfeld</p>
                <a href="tel:+4923514327721" className="block mt-3 text-accent-400 hover:text-accent-300 transition-colors font-medium">
                  02351 4327721
                </a>
                <a href="mailto:info@rahmede.org" className="block text-accent-400 hover:text-accent-300 transition-colors">
                  info@rahmede.org
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-300/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-300/40">
              &copy; {currentYear} Rahmede GmbH. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/impressum" className="text-xs text-background-300/40 hover:text-accent-400 transition-colors">Impressum</Link>
              <Link to="/datenschutz" className="text-xs text-background-300/40 hover:text-accent-400 transition-colors">Datenschutz</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}